import MesuresController from './mesures.controller';

export default {
    template: require('./mesures.tpl.html'),
    controller: MesuresController
};
